import React, { Fragment } from "react";

import { getTestIdForStatus } from "@common/components/DetailsBar/getDetailsBarTestIdentifiers";
import { DropdownItem } from "@common/components/Dropdown/Dropdown";
import Tooltip from "@common/components/Tooltip/Tooltip";
import { TicketStatus } from "@common/models/TicketStatus.model";
import { getStatusIcon } from "@common/util/getIconsHelper";

import * as Styled from "./StatusDropdown.styles";

interface StatusDropdownProps {
  status: TicketStatus;
  isOpened: boolean;
  setIsOpened: (isOpened: boolean) => void;
  changeStatus: (status: TicketStatus) => void;
}

export const StatusDropdown = ({ status, isOpened, setIsOpened, changeStatus }: StatusDropdownProps) => {
  return (
    <Tooltip
      style={{ width: "auto" }}
      position="top"
      text="Set status"
      disabled={status === TicketStatus.LOCKED}
    >
      <Styled.Dropdown
        label={status}
        iconComponent={<Styled.IconContainer>{getStatusIcon(status)}</Styled.IconContainer>}
        buttonElement={<Fragment />}
        position="left"
        isOpened={isOpened}
        setIsOpened={setIsOpened}
        disabled={status === TicketStatus.LOCKED}
      >
        {Object.values(TicketStatus)
          .filter((a) => a !== TicketStatus.LOCKED)
          .map((s) => {
            return (
              <DropdownItem
                key={s}
                onClick={() => {
                  changeStatus(s);
                  setIsOpened(false);
                }}
                testId={getTestIdForStatus(status as Exclude<TicketStatus, TicketStatus.LOCKED>)}
              >
                <Styled.IconContainer>{getStatusIcon(s)}</Styled.IconContainer>
                {s}
              </DropdownItem>
            );
          })}
      </Styled.Dropdown>
    </Tooltip>
  );
};
